import { useCallback } from 'react';

import { utils } from '@core';
import { useAppConfig } from '@state';
import { RESOURCES } from 'types';
import { CreateShareSessionDTO, GetShareLinkDTO } from 'types/Share';
import useSearchParams from './useSearchParams';

export const useShareLink = () => {
	const [appConfig] = useAppConfig();
	const baseURL = appConfig.dataSources[0].configuration.apiRoot;
	const searchParams = useSearchParams();
	const sessionID = utils.splitComma(searchParams.getAll(RESOURCES.SESSION))[0];
	/**
	 * Lấy url share link và password
	 */
	const getShareLink = useCallback(
		async (body: CreateShareSessionDTO): Promise<GetShareLinkDTO> => {
			let shareLink: GetShareLinkDTO;
			if (sessionID) {
				try {
					const response = await fetch(`${baseURL}/${RESOURCES.SESSION}/${sessionID}/${RESOURCES.SHARE}`, {
						method: 'POST',
						headers: {
							'content-type': 'application/json;charset=UTF-8',
						},
						body: JSON.stringify(body),
					});
					if (response.ok) {
						shareLink = await response.json();
						if (shareLink && shareLink.link) {
							shareLink.link += '&mobile_support=1';
						}
					} else {
						console.error('Promise resolved but HTTP status failed');
					}
				} catch (error) {
					console.log(error);
				}
			}

			return shareLink;
		},
		[baseURL, sessionID],
	);

	return { getShareLink };
};
